
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skillbuilders/internshipprep",
      function () {
        return require("private-next-pages/skillbuilders/internshipprep.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skillbuilders/internshipprep"])
      });
    }
  